import { CONFIG } from '../../config';
import { Boss } from '../Boss';
import { Bullet } from '../Bullet';

/**
 * 보스 A - 회전 포탑
 * 화면 중앙에 고정, 방사형 탄막 발사
 */
export class RotatingTurret extends Boss {
    private fireTimer: number = 0;
    private rotationSpeed: number;
    private fireInterval: number;
    private bulletCount: number;
    private targetY: number;
    private targetX: number;
    private enterSpeed: number = 150;

    constructor(canvasWidth: number, canvasHeight: number, isLandscape: boolean = false) {
        // 화면 밖에서 시작 (세로: 상단, 가로: 우측)
        const startX = isLandscape ? canvasWidth + 60 : canvasWidth / 2;
        const startY = isLandscape ? canvasHeight / 2 : -60;
        const health = CONFIG.BOSS.ROTATING_TURRET.HEALTH;

        super(startX, startY, health, 'rotatingTurret', canvasWidth, canvasHeight);

        // 목표 위치 (화면 중앙)
        this.targetX = canvasWidth / 2;
        this.targetY = canvasHeight / 2;

        this.radius = 40;
        this.rotationSpeed = CONFIG.BOSS.ROTATING_TURRET.ROTATION_SPEED;
        this.fireInterval = CONFIG.BOSS.ROTATING_TURRET.FIRE_INTERVAL;
        this.bulletCount = CONFIG.BOSS.ROTATING_TURRET.BULLET_COUNT;
    }

    update(deltaTime: number, playerX: number, playerY: number): void {
        if (!this.isAlive) return;

        // 목표 위치로 이동 (입장 애니메이션)
        const dx = this.targetX - this.x;
        const dy = this.targetY - this.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance > 5) {
            this.x += (dx / distance) * this.enterSpeed * deltaTime;
            this.y += (dy / distance) * this.enterSpeed * deltaTime;
        }

        // 회전
        this.rotation += this.rotationSpeed * deltaTime;

        // 시간이 지날수록 회전 속도 증가
        this.rotationSpeed += deltaTime * 0.1;

        // 목표 위치 근처에서만 총알 발사
        if (distance < 50) {
            this.fireTimer += deltaTime;
            if (this.fireTimer >= this.fireInterval) {
                this.fireTimer = 0;
                this.fireBullets();
            }
        }
    }

    private fireBullets(): void {
        const bulletSpeed = 120;
        const count = 4; // 8에서 4로 줄임

        for (let i = 0; i < count; i++) {
            const angle = this.rotation + (i / count) * Math.PI * 2;
            const vx = Math.cos(angle) * bulletSpeed;
            const vy = Math.sin(angle) * bulletSpeed;

            const bullet = new Bullet(this.x, this.y, vx, vy, '#FFFFFF');
            bullet.hasEnteredPlayArea = true;
            bullet.noBounce = true; // 반사 없이 화면 밖으로 사라짐
            this.bulletBuffer.push(bullet);
        }
    }

    render(ctx: CanvasRenderingContext2D): void {
        if (!this.isAlive) return;

        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rotation);

        // 외곽 원 (하얀색 라인)
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(0, 0, this.radius, 0, Math.PI * 2);
        ctx.stroke();

        // 내부 원 (체력 표시 - 라인만)
        const healthRatio = this.health / this.maxHealth;
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.5)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(0, 0, this.radius * healthRatio, 0, Math.PI * 2);
        ctx.stroke();

        // 포탑 팔 (총알 방향 표시)
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 2;
        for (let i = 0; i < this.bulletCount; i++) {
            const angle = (i / this.bulletCount) * Math.PI * 2;
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(Math.cos(angle) * this.radius * 1.2, Math.sin(angle) * this.radius * 1.2);
            ctx.stroke();
        }

        // 중심 점 (라인으로 변경)
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(0, 0, 5, 0, Math.PI * 2);
        ctx.stroke();

        ctx.restore();
    }

    getName(): string {
        return 'ROTATING TURRET';
    }
}
